import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get collection
// export const getCollaction = createAsyncThunk(
//   "client/get-category-list",
//   async (data, { rejectWithValue }) => {
//     const token = localStorage.getItem("authToken");

//     try {
//       const response = await axios.post(
//         `${baseUrl}`,
//         data,vancouverapis/admin/category/api/v1/get-category
//         {
//           headers: {
//             "auth-token": token,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       return response.data; // ✅ Return only the data
//     } catch (error) {
//       console.error("Error fetching products:", error);

//       // ✅ Handle errors properly
//       return rejectWithValue(
//         error.response?.data?.message || "Failed to fetch products"
//       );
//     }
//   }
// );
export const getCollaction = createAsyncThunk("client/get-category", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}admin/category/api/v1/get-category`, data, {
      headers: {
        "auth-token": token,
      },
    });

    return response.data.response;
  } catch (error) {
    console.error("Error fetching collection - ", error);
    throw error;
  }
});
